module.exports = __webpack_public_path__ + "static/img/purchaseMeeting_bottom.94c45e96.jpg";